/* eslint-disable react/jsx-props-no-spreading */
import { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "../../assets/css/slider.css";

function Sliders({ items }) {
  return <CarouselWithThumbnails items={items} />;
}

export default Sliders;

function CarouselWithThumbnails({ items }) {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const slider1 = useRef(null);
  const slider2 = useRef(null);

  useEffect(() => {
    setNav1(slider1.current);
    setNav2(slider2.current);
  }, []);

  const mainSettings = {
    dots: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    nextArrow: (
      <div>
        <div className="next-slick-arrow">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            stroke="black"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
          >
            <path d="m242-200 200-280-200-280h98l200 280-200 280h-98Zm238 0 200-280-200-280h98l200 280-200 280h-98Z" />
          </svg>
        </div>
      </div>
    ),

    prevArrow: (
      <div>
        <div className="next-slick-arrow rotate-180">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            stroke="black"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
          >
            <path d="m242-200 200-280-200-280h98l200 280-200 280h-98Zm238 0 200-280-200-280h98l200 280-200 280h-98Z" />
          </svg>
        </div>
      </div>
    ),
    beforeChange: (current, next) => setCurrentSlide(next),
    asNavFor: nav2,
  };

  const thumbSettings = {
    slidesToShow: items.length >= 5 ? 5 : items.length,
    slidesToScroll: 1,
    infinite: true,
    focusOnSelect: true,
    asNavFor: nav1,
    ref: slider2,
    centerMode: items.length >= 5,
    variableWidth: items.length < 5,
    autoplay: false,
  };

  return (
    <>
      <div className="carousel-container">
        <Slider {...mainSettings} ref={slider1}>
          {items.map((image, index) => (
            <div key={Math.random()}>
              <div className="img-body">
                <img
                  src={image.logo}
                  alt={`Slide ${index}`}
                  style={{ height: "376px" }}
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
      <div className="thumb-container px-2 rounded">
        <div className="thumb-wrapper d-flex rounded p-2">
          <Slider {...thumbSettings}>
            {items.map((image, index) => (
              <div key={Math.random()}>
                <img
                  src={image.logo}
                  alt={`Thumbnail ${index}`}
                  className={currentSlide === index ? "active" : ""}
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </>
  );
}
